import { JsonProperty, Serializable } from 'ts-jackson'
import { Fromable } from '../model'

@Serializable()
export class PostgrestPagination extends Fromable {
  @JsonProperty('total')
  total?: number

  @JsonProperty('page')
  page?: number

  @JsonProperty('pageSize')
  pageSize?: number
}

@Serializable()
export class PtBookingDashboardRow extends Fromable {
  @JsonProperty('pt_booking_id')
  ptBookingId!: number

  @JsonProperty('member_id')
  memberId!: number

  @JsonProperty('member_code')
  memberCode!: string | null

  @JsonProperty('member_full_name')
  memberFullName!: string | null

  @JsonProperty('trainer_id')
  trainerId!: number

  @JsonProperty('trainer_full_name')
  trainerFullName!: string | null

  @JsonProperty('trainer_type')
  trainerType!: string | null

  @JsonProperty('is_personal_training')
  isPersonalTraining!: boolean

  @JsonProperty('status')
  status!: string

  @JsonProperty('start_time')
  startTime!: string

  @JsonProperty('start_date_local')
  startDateLocal!: string

  @JsonProperty('start_month_local')
  startMonthLocal!: string

  @JsonProperty('weekday')
  weekday!: string

  @JsonProperty('weekday_index')
  weekdayIndex!: number

  @JsonProperty('period')
  period!: string

  @JsonProperty('duration_hours')
  durationHours!: string | number

  @JsonProperty('cancelled_sessions')
  cancelledSessions!: string | number

  @JsonProperty('non_cancelled_sessions')
  nonCancelledSessions!: string | number

  @JsonProperty('completed_sessions')
  completedSessions!: string | number
}

@Serializable()
export class PtBookingDashboardListResponse extends Fromable {
  @JsonProperty({ path: 'data', elementType: PtBookingDashboardRow })
  data?: PtBookingDashboardRow[]

  @JsonProperty({ path: 'pagination', type: PostgrestPagination })
  pagination?: PostgrestPagination
}

@Serializable()
export class TrainerPerformanceOverviewCounts extends Fromable {
  @JsonProperty('totalPrivateTrainers')
  totalPrivateTrainers!: number

  @JsonProperty('totalFullTimePersonalTrainers')
  totalFullTimePersonalTrainers!: number

  @JsonProperty('totalPersonalTrainers')
  totalPersonalTrainers!: number

  @JsonProperty('totalFreelanceTrainers')
  totalFreelanceTrainers!: number
}

@Serializable()
export class SwimmingCoachOverviewCounts extends Fromable {
  @JsonProperty('totalFullTimeSwimmingCoaches')
  totalFullTimeSwimmingCoaches!: number

  @JsonProperty('totalSwimmingCoaches')
  totalSwimmingCoaches!: number

  @JsonProperty('totalFreelanceSwimmingCoaches')
  totalFreelanceSwimmingCoaches!: number
}

@Serializable()
export class DashboardGoalSummaryRow extends Fromable {
  @JsonProperty('goal_unit_key')
  goalUnitKey!: string

  @JsonProperty('training_type')
  trainingType!: string

  @JsonProperty('goal_setting_id')
  goalSettingId!: number

  @JsonProperty('goal_type_id')
  goalTypeId!: number

  @JsonProperty('goal_type')
  goalType!: string

  @JsonProperty('member_id')
  memberId!: number

  @JsonProperty('member_code')
  memberCode!: string | null

  @JsonProperty('member_full_name')
  memberFullName!: string | null

  @JsonProperty('trainer_id')
  trainerId!: number | null

  @JsonProperty('start_date')
  startDate!: string

  @JsonProperty('end_date')
  endDate!: string

  @JsonProperty('raw_status')
  rawStatus!: string | null

  @JsonProperty('assessed_at')
  assessedAt!: string | null

  @JsonProperty('status_updated_at')
  statusUpdatedAt!: string | null

  @JsonProperty('computed_status')
  computedStatus!: string

  @JsonProperty('assessment_status')
  assessmentStatus!: string

  @JsonProperty('all_goals')
  allGoals!: number

  @JsonProperty('achieved_goals')
  achievedGoals!: number

  @JsonProperty('not_achieved_goals')
  notAchievedGoals!: number

  @JsonProperty('in_training_goals')
  inTrainingGoals!: number

  @JsonProperty('total_goals_to_assess')
  totalGoalsToAssess!: number

  @JsonProperty('on_time_assessments')
  onTimeAssessments!: number

  @JsonProperty('late_assessments')
  lateAssessments!: number

  @JsonProperty('unassessed_goals')
  unassessedGoals!: number
}

@Serializable()
export class DashboardGoalSummaryListResponse extends Fromable {
  @JsonProperty({ path: 'data', elementType: DashboardGoalSummaryRow })
  data?: DashboardGoalSummaryRow[]

  @JsonProperty({ path: 'pagination', type: PostgrestPagination })
  pagination?: PostgrestPagination
}

@Serializable()
export class TrainingPlanSummaryFactRow extends Fromable {
  @JsonProperty('goal_session_group_id')
  goalSessionGroupId!: number

  @JsonProperty('goal_setting_id')
  goalSettingId!: number

  @JsonProperty('training_plan_log_id')
  trainingPlanLogId!: number

  @JsonProperty('actual_result_log_id')
  actualResultLogId!: number | null

  @JsonProperty('member_id')
  memberId!: number

  @JsonProperty('member_code')
  memberCode!: string | null

  @JsonProperty('member_full_name')
  memberFullName!: string | null

  @JsonProperty('trainer_id')
  trainerId!: number | null

  @JsonProperty('trainer_full_name')
  trainerFullName!: string | null

  @JsonProperty('training_plan_created_at')
  trainingPlanCreatedAt!: string

  @JsonProperty('training_plan_session_date')
  trainingPlanSessionDate!: string | null

  @JsonProperty('status_bucket')
  statusBucket!: 'AWAIT_RESULT' | 'NOT_ACHIEVED' | 'ACHIEVED' | 'OVER_ACHIEVED'

  @JsonProperty('planned_count')
  plannedCount!: number | string

  @JsonProperty('await_result_count')
  awaitResultCount!: number | string

  @JsonProperty('not_achieved_count')
  notAchievedCount!: number | string

  @JsonProperty('achieved_count')
  achievedCount!: number | string

  @JsonProperty('over_achieved_count')
  overAchievedCount!: number | string

  @JsonProperty('execution_count')
  executionCount!: number | string

  @JsonProperty('success_count')
  successCount!: number | string

  @JsonProperty('year_local')
  yearLocal!: number | string

  @JsonProperty('month_local')
  monthLocal!: number | string
}

@Serializable()
export class TrainingPlanSummaryFactListResponse extends Fromable {
  @JsonProperty({ path: 'data', elementType: TrainingPlanSummaryFactRow })
  data?: TrainingPlanSummaryFactRow[]

  @JsonProperty({ path: 'pagination', type: PostgrestPagination })
  pagination?: PostgrestPagination
}
